import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=3b8c3df4&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=3b8c3df4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c3df4",
  null
  
)

export default component.exports